import clienteAxios from 'config/Axios';

export const getProviders = async (rowsPerPage,page,idLastProvider,filter) => {
  return await clienteAxios.get(`/getProviders?rowsPerPage=${rowsPerPage}&page=${page}&idLastProvider=${idLastProvider}&ruc=${filter.RUC}&providerName=${filter.providerName}`);
}

export const loadProvidersToFirestore = async () =>{
  return await clienteAxios.post('/loadProvidersToFirestore');
}